<section class="top-section">
  <div class="container">
    <h1>{{ 'NAV.HENTERPANT.LEGAL_COMPLIANCE_SUITE' | translate }}</h1>

    <ng-container *ngIf="currentLang === 'no'">
      <p class="last-update">Sist oppdatert: November 2025</p>

      <div class="content" data-header-contrast="light">

        <h2>1. Introduksjon</h2>
        <p>Gi Pant AS følger GDPR, norsk personopplysningslov, Datatilsynets retningslinjer og bransjekrav for digital betaling, datasikkerhet og behandling av barns data.</p>
        <p>Dette sammendraget beskriver hvordan vi beskytter brukere, håndterer data, jobber med sikkerhet og sørger for sikre og transparente betalingsrutiner.</p>
        <p>Fullversjoner av alle juridiske dokumenter finnes i vår Compliance Suite v1.2.</p>

        <h2>2. Roller i systemet</h2>
        <p>Tjenesten benyttes av:</p>
        <ul>
          <li><p><strong>Givere</strong> (bestiller henting)</p></li>
          <li><p><strong>Spillere</strong> (henter panten)</p></li>
          <li><p><strong>Foresatte</strong> (for barn under 15 år, med full kontroll)</p></li>
          <li><p><strong>Lagadministratorer</strong></p></li>
          <li><p><strong>Lag/klubb</strong> (betalende kunde i Henter Pant)</p></li>
        </ul>
        <p>Barn får aldri GPS-behandling og kan ikke egenhendig aktivere kontoen.</p>


        <h2>3. Behandling av personopplysninger</h2>
        <h3>Barn</h3>
        <ul>
            <li><p>Barn under 15 år krever foresattprofil</p></li>
            <li><p>Barn spores aldri via GPS</p></li>
            <li><p>Barnedata behandles med særskilt vern</p></li>
        </ul>

        <h3>Spillere</h3>
        <ul>
            <li><p>Bruker adresse, ikke GPS</p></li>
            <li><p>Kan når som helst sette seg selv på pause</p></li>
        </ul>

        <h3>Foresatte</h3>
        <ul>
            <li><p>Kan aktivere GPS for å motta henteoppdrag</p></li>
            <li><p>GPS leveres av telefonens operativsystem (OS)</p></li>
            <li><p>Lokasjonsdata lagres aldri og slettes automatisk innen 7 dager</p></li>
        </ul>

        <h3>Givere</h3>
        <ul>
            <li><p>Navn, adresse og ordrehistorikk behandles</p></li>
            <li><p>Ingen GPS-data</p></li>
        </ul>

        <h3>Hva vi ikke gjør</h3>
        <ul>
            <li><p>❌ Ingen kontinuerlig sporing</p></li>
            <li><p>❌ Ingen historisk lagring av GPS</p></li>
            <li><p>❌ Ingen bruk av Firebase Analytics</p></li>
            <li><p>❌ Ingen deling av data med tredjeparter for markedsføring</p></li>
        </ul>
 
        <h2>4. Sikkerhetstiltak</h2>
        <ul>
            <li><p>Gi Pant AS bruker moderne og strenge sikkerhetstiltak:</p></li>
            <li><p>TLS 1.3 datakryptering</p></li>
            <li><p>AES-256 lagring</p></li>
            <li><p>Rollebassert tilgangsstyring (RBAC)</p></li>
            <li><p>Pseudonymisering av tekniske logger</p></li>
            <li><p>Immutable audit logs i RocketShadow</p></li>
            <li><p>Sikkerhet- og personvernkontroll ved hver release</p></li>
        </ul>

            <p>Hosting leveres av Hetzner (EU).</p>
            <p>Crashlytics brukes kun for tekniske feil og mottar ingen identitetsdata, GPS eller barnedata.</p>

        <h2>5. GPS og lokasjon</h2>
        <ul>
            <li><p>Kun foresatte kan aktivere GPS</p></li>
            <li><p>Oppdateringsfrekvens styres av iOS/Android (ikke appen)</p></li>
            <li><p>Lokasjon brukes kun for matching av henteoppdrag</p></li>
            <li><p>GPS-data lagres aldri permanent</p></li>
            <li><p>Automatisk sletting etter maks 7 dager</p></li>
            <li><p>Pause-funksjonen stopper all GPS-prosessering umiddelbart</p></li>
        </ul>
        <p>Dette ivaretar barn, foresatte og GDPRs krav til nødvendighet og dataminimering.</p>

        <h2>6. Abonnement og betaling (Henter Pant)</h2>
        <p>Gi Pant AS bruker en todelt betalingsmodell:</p>

        <ol>
            <li><h3>1. Nets Easy</h3>
                <ul>
                    <li><p>brukes kun for første aktivering</p></li>
                    <li><p>én måneds betaling</p></li>
                    <li><p>kreves for å åpne plattformen</p></li>
                </ul>
            </li>
            <li><h3>2. PowerOffice Go</h3>
                <ul>
                    <li>fakturerer videre hver måned</li>
                    <li>abonnement + royalty + fakturagebyr</li>
                    <li>abonnement fornyes automatisk</li>
                    <li>3 måneders oppsigelsestid</li>
                    <li>ingen refusjon for påbegynt fakturamåned</li>
                </ul>
            </li>
            
            <li>
                <h3>Refusjoner</h3>
                <ul>
                    <li>håndteres kun av Gi Pant AS</li>
                    <li>kreditnota via PowerOffice eller reversering ved teknisk feil</li>
                    <li>Nets brukes aldri for donor-betalinger</li>
                </ul>
            </li>
        </ol>

        <h2>7. Misbruk, suspensjon og svindelkontroll</h2>
        <p>Gi Pant AS kan iverksette følgende tiltak ved avvik:</p>
        <ul>
            <li><p>varsel</p></li>
            <li><p>midlertidig suspensjon (7–30 dager)</p></li>
            <li><p>undersøkelsesperiode (inntil 30 dager)</p></li>
            <li><p>permanent utestengelse ved grovt mislighold</p></li>
        </ul>

        <p>Eksempler:</p>
        <ul>
            <li><p>farlig avfall</p></li>
            <li><p>svindel / feilrapportering</p></li>
            <li><p>trusler</p></li>
            <li><p>GPS-manipulasjon</p></li>
            <li><p>gjentatt feilføring</p></li>
            <li><p>manglende betaling (lag suspenderes)</p></li>
        </ul>

        <p>Beslutninger tas av <strong>Gi Pant Support</strong>, og all aktivitet logges i RocketShadow.</p>

        <h2>8. Underleverandører og databehandlere</h2>
        <p>Gi Pant AS bruker følgende databehandlere:</p>
        <ul>
            <li><p>PowerOffice Go (NO) – fakturering</p></li>
            <li><p>Nets (NO/EU) – første betaling</p></li>
            <li><p>Hetzner Cloud (DE) – hosting</p></li>
            <li><p>Google Crashlytics (EU/USA) – tekniske feillogger uten identitet</p></li>
            <li><p>HubSpot (EU/USA) – B2B CRM (aldri app-brukere)</p></li>
        </ul>

        <p>Vi bruker aldri databehandlere for markedsføring av brukere.</p>

        <h2>9. Overføring til tredjeland</h2>
        <p>Kun anonymiserte Crashlytics-feillogger kan sendes til USA.</p>
        <ul>
            <li><p>pseudonymisering</p></li>
            <li><p>ingen GPS</p></li>
            <li><p>ingen identitet</p></li>
            <li><p>ingen barnedata</p></li>
        </ul>
        <p>Residual risiko vurderes som <strong>lav</strong> (se TIA v1.2).</p>

        <h2>10. Dokumentasjon og revisjon</h2>
        <p>Følgende dokumenter inngår i Compliance Suite v1.2:</p>
        <ul>
            <li><p>Terms of Use (Gi Pant + Henter Pant)</p></li>
            <li><p>Privacy Policy</p></li>
            <li><p>DPA</p></li>
            <li><p>Pause Function Specification</p></li>
            <li><p>Misconduct & Suspension</p></li>
            <li><p>Refund & Chargeback Control</p></li>
            <li><p>DPIA – Location & Children</p></li>
            <li><p>ROPA – Register of Processing Activities</p></li>
            <li><p>Change Log Master</p></li>
            <li><p>ELMA Integration</p></li>
            <li><p>TIA – Transfer Impact Assessment</p></li>
        </ul>

        <h2>Revisjonsfrekvens</h2>
        <p>Minst hver 6. måned.</p>
        <p>Neste revisjon: mai 2026.</p>

        <h3 class="mt-5"><a href="../../../assets/legal/Compliance-Suite-HenterPant.pdf" download>Last ned fullstendig versjon av Compliance Suite (PDF)</a></h3>
      </div>
    </ng-container>

    <ng-container *ngIf="currentLang === 'en'">
      <p class="last-update">Last updated: November 2025</p>

      <div class="content" data-header-contrast="light">
        <h2>1. Introduction</h2>
        <p>Gi Pant AS complies with GDPR, the Norwegian Personal Data Act, guidance from the Norwegian Data Protection Authority, and industry standards for digital payments, data security, and the handling of children’s data.</p>
        <p>This summary outlines how we protect users, manage personal data, maintain security, and safeguard transparent payment processes.</p>
        <p>Full versions of every legal document are available in our Compliance Suite v1.2.</p>

        <h2>2. Roles in the system</h2>
        <p>The service is used by:</p>
        <ul>
          <li><p><strong>Donors</strong> (place pickup requests)</p></li>
          <li><p><strong>Players</strong> (collect the deposit bags)</p></li>
          <li><p><strong>Guardians</strong> (for children under 15, with full control)</p></li>
          <li><p><strong>Team administrators</strong></p></li>
          <li><p><strong>Teams / clubs</strong> (paying customers in Henter Pant)</p></li>
        </ul>
        <p>Children never receive GPS processing and cannot activate their accounts on their own.</p>

        <h2>3. Processing of personal data</h2>
        <h3>Children</h3>
        <ul>
          <li><p>Children under 15 require a guardian profile.</p></li>
          <li><p>No GPS tracking of children.</p></li>
          <li><p>Children’s data is handled with enhanced protection.</p></li>
        </ul>

        <h3>Players</h3>
        <ul>
          <li><p>Address-based matching, no GPS.</p></li>
          <li><p>Players can pause themselves at any time.</p></li>
        </ul>

        <h3>Guardians</h3>
        <ul>
          <li><p>May enable GPS to receive pickup requests.</p></li>
          <li><p>GPS data is provided by the device operating system.</p></li>
          <li><p>Location data is never stored and is deleted automatically within seven days.</p></li>
        </ul>

        <h3>Donors</h3>
        <ul>
          <li><p>Name, address, and order history are processed.</p></li>
          <li><p>No GPS data is collected.</p></li>
        </ul>

        <h3>What we do not do</h3>
        <ul>
          <li><p>❌ No continuous tracking.</p></li>
          <li><p>❌ No historical storage of GPS data.</p></li>
          <li><p>❌ No Firebase Analytics.</p></li>
          <li><p>❌ No sharing of data with third parties for marketing.</p></li>
        </ul>

        <h2>4. Security measures</h2>
        <ul>
          <li><p>Gi Pant AS applies modern, rigorous security controls:</p></li>
          <li><p>TLS 1.3 encryption in transit.</p></li>
          <li><p>AES-256 encryption at rest.</p></li>
          <li><p>Role-based access control (RBAC).</p></li>
          <li><p>Pseudonymised technical logging.</p></li>
          <li><p>Immutable audit logs via RocketShadow.</p></li>
          <li><p>Security and privacy checks before every release.</p></li>
        </ul>
        <p>Infrastructure is hosted with Hetzner (EU).</p>
        <p>Crashlytics is used solely for technical errors and receives no identity data, GPS data, or children’s data.</p>

        <h2>5. GPS and location</h2>
        <ul>
          <li><p>Only guardians can enable GPS.</p></li>
          <li><p>Update frequency is controlled by iOS / Android, not the app.</p></li>
          <li><p>Location is used only to match pickup requests.</p></li>
          <li><p>GPS data is never stored permanently.</p></li>
          <li><p>Automatic deletion occurs within seven days.</p></li>
          <li><p>The pause function immediately stops all GPS processing.</p></li>
        </ul>
        <p>These measures protect children and guardians while satisfying GDPR principles of necessity and data minimisation.</p>

        <h2>6. Subscription and payments (Henter Pant)</h2>
        <p>Gi Pant AS uses a two-stage payment model:</p>
        <ol>
          <li>
            <h3>1. Nets Easy</h3>
            <ul>
              <li><p>Used only for the initial activation.</p></li>
              <li><p>Covers one month of access.</p></li>
              <li><p>Required to unlock the platform.</p></li>
            </ul>
          </li>
          <li>
            <h3>2. PowerOffice Go</h3>
            <ul>
              <li><p>Handles every subsequent monthly invoice.</p></li>
              <li><p>Includes subscription, royalty, and invoicing fee.</p></li>
              <li><p>Subscription renews automatically.</p></li>
              <li><p>Three-month cancellation notice.</p></li>
              <li><p>No refunds for calendar months already in progress.</p></li>
            </ul>
          </li>
          <li>
            <h3>Refunds</h3>
            <ul>
              <li><p>Managed exclusively by Gi Pant AS.</p></li>
              <li><p>Issued as a credit note via PowerOffice or a reversal if a technical error occurs.</p></li>
              <li><p>Nets is never used for donor payments.</p></li>
            </ul>
          </li>
        </ol>

        <h2>7. Misconduct, suspension, and fraud control</h2>
        <p>Gi Pant AS may implement the following measures when irregularities occur:</p>
        <ul>
          <li><p>Warning.</p></li>
          <li><p>Temporary suspension (7–30 days).</p></li>
          <li><p>Investigation period (up to 30 days).</p></li>
          <li><p>Permanent exclusion for serious breaches.</p></li>
        </ul>
        <p>Examples include hazardous waste, fraud or misreporting, threats, GPS manipulation, repeated incorrect logging, and non-payment (team suspension).</p>
        <p>Decisions are handled by <strong>Gi Pant Support</strong>, and all activity is logged in RocketShadow.</p>

        <h2>8. Sub-processors and data processors</h2>
        <p>Gi Pant AS collaborates with the following processors:</p>
        <ul>
          <li><p>PowerOffice Go (NO) – invoicing.</p></li>
          <li><p>Nets (NO / EU) – initial payment.</p></li>
          <li><p>Hetzner Cloud (DE) – hosting.</p></li>
          <li><p>Google Crashlytics (EU / USA) – technical error logs without identity data.</p></li>
          <li><p>HubSpot (EU / USA) – B2B CRM (never app users).</p></li>
        </ul>
        <p>We never use processors to market to app users.</p>

        <h2>9. Transfer to third countries</h2>
        <p>Only anonymised Crashlytics error logs may be sent to the United States.</p>
        <ul>
          <li><p>SCC 2021 safeguards.</p></li>
          <li><p>Pseudonymisation.</p></li>
          <li><p>No GPS data.</p></li>
          <li><p>No identity data.</p></li>
          <li><p>No children’s data.</p></li>
        </ul>
        <p>Residual risk is assessed as <strong>low</strong> (see TIA v1.2).</p>

        <h2>10. Documentation and revision</h2>
        <p>The following documents are part of Compliance Suite v1.2:</p>
        <ul>
          <li><p>Terms of Use (Gi Pant + Henter Pant).</p></li>
          <li><p>Privacy Policy.</p></li>
          <li><p>Data Processing Agreement (DPA).</p></li>
          <li><p>Pause Function Specification.</p></li>
          <li><p>Misconduct &amp; Suspension.</p></li>
          <li><p>Refund &amp; Chargeback Control.</p></li>
          <li><p>DPIA – Location &amp; Children.</p></li>
          <li><p>ROPA – Register of Processing Activities.</p></li>
          <li><p>Change Log Master.</p></li>
          <li><p>ELMA Integration.</p></li>
          <li><p>TIA – Transfer Impact Assessment.</p></li>
        </ul>

        <h2>Revision frequency</h2>
        <p>At least every six months.</p>
        <p>Next review: May 2026.</p>

        <h3 class="mt-5"><a href="../../../assets/legal/Compliance-Suite-HenterPant.pdf" download>Download the full Compliance Suite (PDF)</a></h3>
      </div>
    </ng-container>

  </div>
</section>